import escapeRegExp from '../../../../../../../../utils/escapeRegExp.ts';
import type { SubstitutionMap } from './types.ts';

type ApplySubstitutionsParams = {
  content: string;
  substitutions: SubstitutionMap;
};

const applySubstitutions = ({ content, substitutions }: ApplySubstitutionsParams): string =>
  Object.entries(substitutions)
    .reduce(
      (memo, [key, value]) => memo.replace(new RegExp(escapeRegExp(key), 'g'), value),
      `${content}`
    )
    // Cleanup: remove any leftover %MERGE_TAG% tokens that weren't substituted
    .replace(/%[A-Z][A-Z0-9_]*%/g, '');

export default applySubstitutions;
